import template from "./map.html";
import _ from "lodash";
import { setOptions, importLibrary } from "@googlemaps/js-api-loader";

class MapController {
    /* @ngInject */
    constructor($document, $scope, $q) {
        this.$document = $document;
        this.$scope = $scope;
        this.$q = $q;
    }

    $onInit() {
        let ctrl = this;

        setOptions({
            key: process.env.GOOGLE_PUBLIC_API_KEY,
            v: "weekly",
            libraries: ["maps", "core", "marker"],
        });

        let mapsLibrary = importLibrary("maps");
        let markerLibrary = importLibrary("marker");
        let coreLibrary = importLibrary("core");
        ctrl.$q
            .all([mapsLibrary, markerLibrary, coreLibrary])
            .then(function (libs) {
                let [maps, marker, core] = libs;
                const map = new maps.Map(
                    ctrl.$document[0].getElementById(
                        "announcement-location-map",
                    ),
                    {
                        zoom: 15,
                        mapTypeId: "hybrid",
                        fullscreenControl: false,
                        streetViewControl: false,
                        controlSize: 20,
                    },
                );

                function updateMarker(marker, position) {
                    console.log(marker, position);
                    marker.setPosition(position);
                    map.panTo(marker.getPosition());
                    ctrl.onMarkerUpdate({ position: marker.getPosition() });
                    marker.addListener("dragend", function () {
                        ctrl.onMarkerUpdate({ position: marker.getPosition() });
                        map.panTo(marker.getPosition());
                    });
                }

                let centerPosition;
                if (_.isNil(ctrl.markerLat) && _.isNil(ctrl.markerLng)) {
                    centerPosition = {
                        lat: ctrl.centerLat,
                        lng: ctrl.centerLng,
                    };
                    let clickListener = map.addListener("click", function (e) {
                        if (_.isNil(ctrl.marker)) {
                            core.event.removeListener(clickListener);
                            ctrl.marker = new marker.Marker({
                                map: map,
                                draggable: true,
                            });
                            ctrl.onMarkerUpdate({ position: e.latLng });
                        }
                    });
                } else {
                    centerPosition = {
                        lat: ctrl.markerLat,
                        lng: ctrl.markerLng,
                    };
                    ctrl.marker = new marker.Marker({
                        map: map,
                        draggable: !ctrl.static,
                    });
                    updateMarker(ctrl.marker, centerPosition);
                }
                map.setCenter(centerPosition);

                if (!ctrl.static) {
                    ctrl.$scope.$watch("$ctrl.markerLat", function () {
                        if (
                            !_.isNil(ctrl.markerLat) &&
                            !_.isNil(ctrl.markerLng)
                        ) {
                            let position = {
                                lat: ctrl.markerLat,
                                lng: ctrl.markerLng,
                            };
                            console.log("firing here");
                            if (_.isNil(ctrl.marker)) {
                                ctrl.marker = new marker.Marker({
                                    map: map,
                                    draggable: true,
                                });
                            }
                            updateMarker(ctrl.marker, position);
                        }
                    });
                }
            });
    }
}
export default {
    bindings: {
        markerLat: "=",
        markerLng: "=",
        centerLat: "<",
        centerLng: "<",
        static: "<",
        onMarkerUpdate: "&",
    },
    controller: MapController,
    template: template,
    name: "dynamicMap",
};
